import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../services/system/storage.service';
import { InvoiceTheme } from '../../../models/inModels/InvoiceTheme';
import { InvoiceThemeService } from '../../../services/invoice-theme/invoice-theme.service';

@Component({
  selector: 'app-edit-invoice-theme',
  templateUrl: './edit-invoice-theme.component.html'
})

export class EditInvoiceThemeComponent  {
	model: InvoiceTheme;
	loading = false;
	error: Message[];
	messages: Message[];
	id;
	constructor(
		public storageService: StorageService,
		private router: Router,
		private route: ActivatedRoute,
		private service: InvoiceThemeService,) {
		this.model = new InvoiceTheme();
	}

	ngOnInit() {
		this.loading = true;
		this.id = this.route.snapshot.params.Id;
		this.service.get(this.id).then(
			theme => {
				this.model = new InvoiceTheme(theme);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	goBack(): void {
		this.router.navigate(['/invoice-theme']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				console.log("Theme edited", result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}


	handleBackgroundImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.backgroundImage = result.PublicId;
		this.loading = false;
	}


	handleDisplayImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.displayImage = result.PublicId;
		this.loading = false;
	}
		
	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/invoice-themes/edit-invoice-theme/edit-invoice-theme.component.ts